import axios from "src/utils/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

//getMembership Data
export const getMembershipList = createAsyncThunk(
  "admin/getMembershipList",
  // Callback Function
  async ({}, thunkAPI) => {
    try {
      const response = await axios.get(`admin/membership-list`);
      return await response.data;
    } catch (error) {
      const message =
        error.response && error.response.data
          ? error.response.data.message
          : "Something Went Wrong";
      return thunkAPI.rejectWithValue(message);
    }
  }
);
